import {AbstractControl, FormGroup} from '@angular/forms';
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {Config} from '../../../models/config';
import {UpdateDynamicFormService} from '../../../services/update-dynamic-form.service';
import {Subscription} from 'rxjs';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss']
})
export class FormInputComponent  implements OnInit {

  config: Config;
  group: FormGroup;
  errorAllow: boolean;
  isEdit: boolean;
  toggleElements: boolean;
  controlName = null;
  showWarning: boolean;
  duplicate = false;
  private sub$: Subscription;
  private subscriptions = [];
  constructor( @Inject(L10N_LOCALE) public locale: L10nLocale, private updateDynamicFormService: UpdateDynamicFormService , private cdr: ChangeDetectorRef) {

  }

  ngOnInit(): void {
    if (this.config && this.config.options) {
      if (this.config.options.toggle !== undefined && this.config.options.toggle === false) {
        this.toggleElements = false;
      }
      if (this.config.options.toggle === undefined) {
        this.toggleElements = true;
      }
      this.updateStatus();
    }
  }

  get getControlName(): AbstractControl {
    return this.group.controls[this.config.controlName[0]];
  }

  getValueFromGroup(): string {
    let concatenated = '';
    this.config.options.concatenate.forEach(name => {
      if (this.group.get(name) && this.group.get(name).value) {
        concatenated += this.group.get(name).value + ' ';
      }
    });
    return concatenated;
  }
  /**
   * cette fonction update le bon boolean pour le bon contrôleur et pour le bon type
   * Actuellement il n'y a que le type toggle qui permet de cacher/afficher un element
   * @param le nom du controller actuelle
   *
   */
  getStatus(name: string): void {

    const warningStatus = this.updateDynamicFormService.status(name);
    if (warningStatus) {
      this.controlName = warningStatus.controlName;
      if (name === this.controlName) {
         if ( warningStatus.type === 'toggle') {
          this.toggleElements =  warningStatus.status;
          this.cdr.markForCheck();
        }
         if ( warningStatus.type === 'warning') {
          this.showWarning = warningStatus.status;
          this.cdr.markForCheck();
        }
         if ( warningStatus.type === 'duplicate') {
           this.duplicate = warningStatus.status;
           this.cdr.markForCheck();
        }

      }
    }
  }
  updateStatus(): void {
    this.sub$ = this.updateDynamicFormService.getResponse().subscribe((data) => {
      if (data && this.config) {
        this.getStatus(this.config.controlName[0]);
      }
    });
    this.subscriptions.push(this.sub$);
  }
}
